(() => {
  const records = [
    {
      id: 'CKC-KA-1399',
      title: 'Understanding BALUN, UNUN, and Matching-Transformer Power Handling',
      handle: 'understanding-balun-unun-and-matching-transformer-power-handling',
      quick: 'Published SSB, CW, and digital ratings are ceilings under suitable conditions; safe power also depends on impedance, frequency, loss, voltage/current stress, common-mode current, duty cycle, temperature, tuner location, and the complete RF system.',
      summary: 'Learn why SWR is not transformer heat, how mismatch changes voltage and current stress, why mode and duty cycle matter, how tuner location can hide antenna-side stress, and how to increase power safely with a BALUN, UNUN, HYBRID, or integrated matching network.',
      category: 'Feed Lines & RF Components',
      section: 'Matching & Isolation Devices',
      keywords: 'BALUN power handling, UNUN power handling, transformer heating, matching transformer, HYBRID MINI, HYBRID MICRO, SWR, reflected power, return loss, mismatch, ferrite core loss, saturation, winding loss, common mode current, duty cycle, SSB, CW, digital modes, FT8, RTTY, ICAS, tuner location, feed line loss, temperature rise, thermal failure, 2.7 to 1 SWR',
      seoTitle: 'BALUN, UNUN and Transformer Power Handling Explained | CKB',
      metaDescription: 'Understand how SWR, impedance, frequency, transformer loss, duty cycle and heat determine safe BALUN, UNUN and matching-network power.',
      difficulty: 'Intermediate to Advanced',
      readingTime: '24-30 min',
      revision: '1.0',
      reviewed: '2026-07-20',
      url: '/pages/chameleon-knowledge-base?article=understanding-balun-unun-and-matching-transformer-power-handling',
      published: true,
      canonicalHandle: 'understanding-balun-unun-and-matching-transformer-power-handling',
      canonicalId: 'CKC-KA-1399',
      editorialStatus: 'source_governed',
      bodyChunk: '28',
      relatedHeadings: [
        'Quick Answer',
        'Why a Single Wattage Cannot Describe Every Installation',
        'Forward Power, Reflected Power, and Heat Are Different Quantities',
        'Why High SWR Can Still Damage a Transformer',
        'The Same SWR Can Represent Very Different Loads',
        'Low SWR Is Not a Complete Safety Certificate',
        'Where the SWR Is Measured Matters',
        'Where Transformer Heat Comes From',
        'Duty Cycle and Operating Mode Often Determine the Thermal Limit',
        'Current CHAMELEON Rating Examples',
        'Understanding the 2.7:1 Example',
        'A Safe Field Procedure for Increasing Power',
        'Stop-Work Indicators',
        'A Systematic Troubleshooting Sequence',
        'Common Misconceptions',
        'Operator Decision Guide',
        'Source and Freshness Note'
      ],
      sourceReviewed: '2026-07-20',
      sourceAuthority: 'Current Chameleon product pages and official product guides; ARRL Handbook and Antenna Book; Jerry Sevick transmission-line-transformer and BALUN/UNUN references',
      freshnessPolicy: 'Review after any Chameleon transformer design, product page, user guide, power rating, duty-cycle, frequency, compatibility, or safety change.'
    }
  ];

  window.CKB_SEARCH_INDEX = Array.isArray(window.CKB_SEARCH_INDEX) ? window.CKB_SEARCH_INDEX : [];
  const handles = new Set(window.CKB_SEARCH_INDEX.map(record => record.handle));
  records.forEach(record => {
    if (!handles.has(record.handle)) window.CKB_SEARCH_INDEX.push(record);
  });
})();
